export const CAROUSEL_PADDINGS = {
  PADDING_TOP_SPECIAL_ROW: '--padding-top-special-row-face-card',
  VERTICAL_PADDINGS_EPISODES_ROW_DETAILS_PAGE:
    '--carousel--vertical-paddings-episodes-row-details-page',
} as const
export type CAROUSEL_PADDINGS =
  (typeof CAROUSEL_PADDINGS)[keyof typeof CAROUSEL_PADDINGS]
